import Handlebars from "handlebars";
import {t} from "@lingui/core/macro";

export default () => Handlebars.compile(`<div class="public" style="text-align: center; margin-top: 10px">
    <h2>${t`Sorry, this information is not visible to you.`}</h2>
</div>`) as any;
